import {
  Delete as DeleteIcon,
  Add as AddIcon,
  DragIndicator as DragIcon,
  Upload as UploadIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  IconButton,
  Box,
  Typography,
  Card,
  CardContent,
  Collapse,
  Grid,
  styled,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Dialog,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import DynamicDataCaptureModal, {
  FieldConfig,
} from "0.Mine/0.Components/Reusable/DataCaptureModal";
import GenericTable from "0.Mine/0.Components/Reusable/GenericTable";
import { BusinessService } from "0.Mine/3.Interfaces/Services";

import { SERVICE_CATEGORIES } from "../Logic/TreatmentTable";

const fields: FieldConfig[] = [
  {
    key: "name",
    label: "Nome",
    type: "text",
    required: true,
  },
  {
    key: "description",
    label: "Descrizione",
    type: "text",
    required: true,
  },
  {
    key: "price",
    label: "Prezzo",
    type: "number",
    required: true,
  },
  {
    key: "duration",
    label: "Durata (minuti)",
    type: "number",
    required: true,
  },
  {
    key: "category",
    label: "Categoria",
    type: "select",
    options: SERVICE_CATEGORIES,
    required: false,
  },
  {
    key: "isPopular",
    label: "Popolare?",
    type: "checkbox",
    required: false,
  },
];

interface NewTreatmentFormProps {
  isMobile: boolean;
  newTreatment: any;
  onChange: (field: string, value: string | boolean) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  open: boolean;
  setOpen: (value: boolean) => void;
}

export const NewTreatmentForm: React.FC<NewTreatmentFormProps> = ({
  newTreatment,
  onChange,
  onSubmit,
  open,
  setOpen,
}) => {
  return (
    <DynamicDataCaptureModal
      isOpen={open}
      onClose={() => setOpen(false)}
      onSubmit={onSubmit}
      initialData={newTreatment}
      fields={fields}
      modalTitle="Aggiungi un servizio"
    />
  );
};

interface DesktopViewProps {
  treatments: BusinessService[];
  isAdding: boolean;
  setIsAdding: (value: boolean) => void;
  newTreatment: any;
  handleNewTreatmentChange: (field: string, value: string | boolean) => void;
  handleSubmit: (e: React.FormEvent) => void;
  cancelAdding: () => void;
  triggerFileInput: (treatmentId: number, image: File) => Promise<void>;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  handleImageUpload: (
    e: React.ChangeEvent<HTMLInputElement | null>,
    isNew: boolean,
    index?: number
  ) => void;
  onDelete: (index: number) => void;
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  editingTreatment: BusinessService | null;
  setEditingTreatment: (treatment: BusinessService | null) => void;
  handleEditTreatmentChange: (field: string, value: string | boolean) => void;
  handleEditSubmit: (e: React.FormEvent) => void;
}

export const DesktopView: React.FC<DesktopViewProps> = ({
  treatments,
  isAdding,
  setIsAdding,
  newTreatment,
  handleNewTreatmentChange,
  handleSubmit,
  cancelAdding,
  triggerFileInput,
  onDelete,
  isEditing,
  setIsEditing,
  editingTreatment,
  setEditingTreatment,
  handleEditTreatmentChange,
  handleEditSubmit,
}) => {
  const handleEditService = (service: BusinessService) => {
    const serviceCopy = { ...service };
    setEditingTreatment(serviceCopy);
    setIsEditing(true);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          p: 2,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <IconButton
          onClick={() => setIsAdding(true)}
          sx={{
            padding: "5px",
            background: "url(https://qlickup.it/wp-content/uploads/2025/04/SFONDO-1.jpg)",
            backgroundSize: "cover",
            color: "white!important",
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "rotate(90deg)",
            },
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>
      <GenericTable
        columns={["Name", "Price", "description", "duration", "isPopular"]}
        columnLabels={{
          Name: "Nome",
          Price: "Prezzo",
          description: "Descrizione",
          duration: "Durata",
          isPopular: "Popolare",
        }}
        data={treatments}
        rowActions={[
          {
            name: "Edit",
            onClick: (rowData) => handleEditService(rowData),
          },
          {
            name: "Delete",
            onClick: (rowData) => onDelete(rowData.id),
          },
        ]}
        noDataMessage="Nessun servizio disponibile. Aggiungine uno!"
        imageColumn={{
          field: "photoUrl",
          width: 100,
          height: 100,
          editable: true,
          onImageUpdate: triggerFileInput,
        }}
      />
      <NewTreatmentForm
        newTreatment={newTreatment}
        onChange={handleNewTreatmentChange}
        onSubmit={handleSubmit}
        onCancel={cancelAdding}
        open={isAdding}
        setOpen={setIsAdding}
        isMobile={false}
      />

      <NewTreatmentForm
        newTreatment={editingTreatment || {}}
        onChange={handleEditTreatmentChange}
        onSubmit={handleEditSubmit}
        onCancel={() => setIsEditing(false)}
        open={isEditing}
        setOpen={setIsEditing}
        isMobile={false}
      />
    </>
  );
};
